import * as React from "react";
import { LoadStateAsync, SaveStateAsync } from "source/app/infrastructure/Data/MotwIndexedDb";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";

export function useIndexedDb<T>(
	key: ESharedFunction,
	value: T,
) {
	React.useEffect(() => {
		const Load = async () => await LoadStateAsync(key);
		Load();
	}, []);

	React.useEffect(
		() => {
			const Save = async () => await SaveStateAsync(key);
			Save();
		},
		[ value ]
	);
}
